import React from "react";

class PortalFooter extends React.Component {
    render() {
        return (
            <>

            </>
        );
    }
}

export default PortalFooter;